import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MagicLinkService } from '../Services/magic-link.service';

@Component({
    selector: 'app-magic-link-auth',
    templateUrl: './magic-link-auth.component.html',
    styleUrls: ['./magic-link-auth.component.css'],
    standalone: false
})
export class MagicLinkAuthComponent implements OnInit, OnDestroy {
  isLoading = true;
  errorMessage = '';
  
  // Loading steps for better UX
  loadingSteps = [
    { text: 'Verifying your credentials', icon: '🔐', completed: false },
    { text: 'Loading your account', icon: '👤', completed: false },
    { text: 'Preparing your workspace', icon: '✨', completed: false },
    { text: 'Almost there', icon: '🚀', completed: false }
  ];
  currentStepIndex = 0;
  isMobileOnboardingWarning = false;
  private stepInterval: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private magicLinkService: MagicLinkService
  ) { }

  ngOnInit(): void {
    const intent = this.route.snapshot.queryParams['intent'];
    const loginCode = this.route.snapshot.queryParams['login_code'];

    // Check if user is already logged in and there's no new code to verify
    if (this.isUserAlreadyLoggedIn() && !loginCode) {
      this.router.navigate(['/setup'], { queryParams: { step: 'intro' } });
      return;
    }

    
    // Simple mobile check
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isMobileDevice = /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent);

    if (intent === 'onboarding' && isMobileDevice) {
       this.isLoading = false;
       this.isMobileOnboardingWarning = true;
       return;
    }

    this.startLoadingAnimation();
    this.processMagicLink();
  }

  ngOnDestroy(): void {
    if (this.stepInterval) {
      clearInterval(this.stepInterval);
    }
  }

  /**
   * Start the loading steps animation
   */
  private startLoadingAnimation(): void {
    // Mark first step as in progress
    this.stepInterval = setInterval(() => {
      if (this.currentStepIndex < this.loadingSteps.length - 1) {
        this.loadingSteps[this.currentStepIndex].completed = true;
        this.currentStepIndex++;
      }
    }, 1500);
  }

  /**
   * Check if user is already logged in
   */
  private isUserAlreadyLoggedIn(): boolean {
    const isLoggedIn = localStorage.getItem('isLogedIn') === 'true';
    return isLoggedIn;
  }

  /**
   * Process the magic link authentication
   */
  private processMagicLink(): void {
    const loginCode = this.route.snapshot.queryParams['login_code'];
    const email = this.route.snapshot.queryParams['email'];
    const intent = this.route.snapshot.queryParams['intent'];

    if (!loginCode) {
      this.showError('Invalid magic link. Missing login code. Please request a new one.');
      return;
    }

    // Use the magic link service to process authentication
    // The service will handle redirection automatically on success
    this.magicLinkService.processMagicLinkAuthentication(loginCode, email, intent);

    // Keep loading state active - will be redirected by service on success
    // or show error if authentication fails
  }

  // Method to handle when the user verified an onboarding link on desktop
  // The backend already handles the association so we just proceed.

  goToLogin(): void {
    this.router.navigate(['/login']);
  }

  private showError(message: string): void {
    this.isLoading = false;
    this.errorMessage = message;
  }
}
